import { render, staticRenderFns } from "./loanpage.vue?vue&type=template&id=a29d2874&"
import script from "./loanpage.vue?vue&type=script&lang=js&"
export * from "./loanpage.vue?vue&type=script&lang=js&"
import style0 from "./loanpage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports